import styled from 'styled-components';

export const InfoWrapper = styled.div`
  display: flex;
`;

export const InfoBlock = styled.div`
  margin-right: 48px;
`;

export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;

  & > div:first-child {
    margin-right: 8px;
  }

  & > div:last-child {
    max-width: 262px;
    word-break: break-word;
  }
`;

export const EmployeeListWrapper = styled.div`
  & > div {
    display: flex;
    margin-bottom: 8px;

    & > div > div:last-child {
      cursor: pointer;
      :hover {
        color: ${({ theme }) => theme.colors.primary.blue};
      }
    }

    span {
      margin-right: 8px;
    }
  }
`;

export const EmployeesWrapper = styled.div`
  max-height: 155px;
  box-sizing: border-box;
  overflow-y: auto;
`;
